$(document).ready(function() {

    let pageContentList = $('div#logistics_introduction_wrapper nav#page_content_list');

    if (pageContentList.length) {
        let offsetTop = pageContentList.offset().top;

        $(document).on('click', 'div#logistics_introduction_wrapper nav#page_content_list li a', function(event) {
            event.preventDefault();
            $($(this).attr('href'))[0].scrollIntoView();
            scrollBy(0, -offsetTop);
        });
    }


});